import { VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useInstallMeterStepsStore } from '../../components/store';
import { Button } from '../../../../components/Button/Button';
import { useStore } from '../../useStore';
import { ReviewStepFooter as messages } from './messages';

export const ReviewStepFooter: VFC = () => {
  const { isSendingData } = useStore();
  const { setPreviousStep } = useInstallMeterStepsStore();
  const intl = useIntl();

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button key="submit" block form="reviewStepForm" htmlType="submit" loading={isSendingData} type="primary">
        {isSendingData ? intl.formatMessage(messages.sending) : intl.formatMessage(messages.confirm)}
      </Button>
    </>
  );
};
